/* src/app/contract/contract-sales-form/contract-sales-form.component.css */
:host ::ng-deep .p-dropdown {
  width: 100% !important;
  max-width: 100% !important;
}
:host ::ng-deep .p-dropdown-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/*# sourceMappingURL=contract-sales-form.component-YP7V634U.css.map */
